import React from 'react';

const Form = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <title>form</title>
    <path
      d="M20,2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2Zm0,18H4V4H20Z"
      transform="translate(-2 -2)"
    />
    <rect x="8.9" y="5.52" width="8.04" height="1.45" />
    <rect x="8.9" y="8.19" width="8.04" height="1.45" />
    <rect x="8.9" y="10.89" width="8.04" height="1.45" />
    <rect x="11.2" y="13.57" width="5.67" height="1.13" />
    <rect x="3.04" y="5.51" width="4.67" height="1.39" />
    <rect x="3.04" y="8.21" width="4.67" height="1.39" />
    <rect x="3.04" y="10.9" width="4.67" height="1.39" />
  </svg>
);

export default Form;
